import React, { useState, useContext, useRef, useEffect } from "react";
import { ResumePopupContext } from "../../Context/resumePopupContext";
import { jsonEditorContext } from "../../Context/jsonEditorContext";
import ReactQuill, { Quill } from "react-quill";
import { useSelector } from "react-redux";
import ErrorMessage from "../../Components/Analyzer/ErrorPopup/ErrorPopup";
import "./Quilleditor.scss";

function Quilleditor(props, ref) {
  //Destrucure Props
  const {
    type,
    inivalue,
    current,
    setvalue,
    onBlur,
    className,
    placeholder,
    sectionId,
    styles,
  } = props;

  //Value Assign
  const toolbar = [
    "bold",
    "italic",
    "underline",
    { list: "ordered" },
    { list: "bullet" },
  ];
  const path = window.location.pathname;

  //Local states
  const [quilFocus, setQuilFoucs] = useState(false);

  //Context
  const { preview, setPreview } = useContext(ResumePopupContext);
  const analyzerData = useSelector((state) => state.analyzeResume.data);

  //Refs
  const reactQuillRef = useRef(null);

  //Functions

  const isHTML = (str) =>
    !(str || "")
      // replace html tag with content
      .replace(/<([^>]+?)([^>]*?)>(.*?)<\/\1>/gi, "")
      // remove remaining self closing tags
      .replace(/(<([^>]+)>)/gi, "")
      // remove extra space at start and end
      .trim();

  const onChangeSelection = (range, oldRange, source) => {
    if (type != "basic") {
      if (range) {
        if (range.length == 0) {
          props.changesetShowQuillToolbar(true);
        } else {
          props.changesetShowQuillToolbar(false);
          reactQuillRef.current.editor.theme.tooltip.show();
        }
      } else {
        props.changesetShowQuillToolbar(true);
      }
    }
  };

  const quillFocus = (e) => {
    setQuilFoucs(!preview ? true : false);

    if (props && props.sectionId != "summary") {
      if (inivalue == "" || inivalue == null || inivalue == "<p><br></p>") {
        if (
          reactQuillRef &&
          reactQuillRef.current &&
          reactQuillRef.current.editor &&
          reactQuillRef.current.editor != ""
        ) {
          reactQuillRef &&
            reactQuillRef.current &&
            reactQuillRef.current.editor &&
            reactQuillRef.current.editor.format("list", "bullet");
        }
      }
    }
  };

  const { improveTexts, setImproveTexts } = useContext(jsonEditorContext);
  const alteredSectionID = improveTexts[
    `${sectionId.charAt(0).toUpperCase()}${sectionId.slice(1)}`
  ]
    ? sectionId.charAt(0).toUpperCase() + sectionId.slice(1)
    : sectionId;

  const [highLightError, setHighlightError] = useState(false);
  const [errorData, setErrorData] = useState("");
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const dataArray = analyzerData?.[sectionId]?.items?.[current];
    if (dataArray) {
      const foundItem = dataArray.find((item) => item["key"] === "description");
      if (foundItem?.mistake?.length > 0) {
        setHighlightError(false);
        setErrorData(foundItem);
        // console.log("Found item:", foundItem);
      }
    }
  }, [inivalue, props]);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <ReactQuill
        format={"list"}
        ref={reactQuillRef}
        placeholder={placeholder}
        onChangeSelection={onChangeSelection}
        theme={type == "basic" ? "snow" : "bubble"}
        className={` quill_line ${className}${
          quilFocus ? ` quil-focused` : ``
        }`}
        value={isHTML(inivalue) ? inivalue : `<li>${inivalue}</li>`}
        style={{
          backgroundColor:
            !preview && !path.includes("preview") && highLightError
              ? "#d17676"
              : "unset",
          color: styles.isMandatoryDescriptionColor
            ? styles.secondaryColor
            : "#1F1F1F",
          fontFamily:
            type && type == "basic"
              ? ""
              : `${styles?.bodyFont}, Arial, Helvetica, "Noto Sans Devanagari", "Noto Sans CJK SC Thin", "Noto Sans SC", "Noto Sans Hebrew", sans-serif`,
          fontSize:
            type && type == "basic"
              ? "13px"
              : styles?.selectedFont?.p1
              ? styles?.selectedFont?.p1
              : "13px",
          lineHeight: "18px",
          fontWeight: "400",
          paddingTop: sectionId && sectionId != "summary" ? "10px" : "unset",
        }}
        onChange={(newValue, delta, source) => {
          setvalue(newValue, current, sectionId, source, type);
        }}
        modules={{
          toolbar: toolbar,
          clipboard: {
            matchVisual: false,
          },
        }}
        onFocus={(e) => quillFocus(e)}
        onBlur={(e) => {
          if (onBlur) {
            onBlur();
          }
          if (type != "basic") {
            props.changesetShowQuillToolbar(true);
          }
          reactQuillRef.current.editor.theme.tooltip.hide();
          setQuilFoucs(false);
        }}
      ></ReactQuill>
      {/* {isHovered && highLightError && (
        <ErrorMessage
          errors={errorData.mistake}
          suggestions={errorData.correction}
        />
      )} */}
    </div>
  );
}
export default Quilleditor;
